import React from "react";
import { Route, Routes } from "react-router-dom";

import View from "./View";
import List from "./List";

const Index = () => (
  <Routes>
    <Route path="/" element={<List />} />
    <Route path="/:id" element={<View />} />
  </Routes>
);

export default Index;
